import { render, staticRenderFns } from "./simplifyShopFee.vue?vue&type=template&id=43898995&scoped=true"
import script from "./simplifyShopFee.vue?vue&type=script&lang=js"
export * from "./simplifyShopFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyShopFee.vue?vue&type=style&index=0&id=43898995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43898995",
  null
  
)

export default component.exports